<template>
  <b-modal
    id="advance-fund-reject-modal"
    title="ยืนยันการไม่อนุมัติงบสำรองจ่ายและระบุความคิดเห็น"
    size="lg"
    ok-title="ไม่อนุมัติงบสำรองจ่าย"
    ok-variant="danger"
    cancel-title="ยกเลิก"
    @ok="submit"
  >
    โปรดระบุเหตุผล/ความเห็นประกอบการไม่อนุมัติงบสำรองจ่าย
    <b-form-textarea
      v-model="reason"
      class="mt-3"
      placeholder="ระบุเหตุผลหรือความเห็น"
      rows="10"
    />
  </b-modal>
</template>

<script>
export default {
  data: () => ({
    reason: ''
  }),
  methods: {
    async submit () {
      this.$emit('confirm', this.reason)
    }
  }
}
</script>
